<p class="modal-title">Sex assigned at birth</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>Your response is used to consider health risk factors specific to particular sexes. These risk factors impact lifetime healthcare costs and life expectancy.</p>